<template>
  <div class="page">
    <!-- 负责人 -->
    <div class="topBox" v-if="feedShop">
      <el-row type="flex" class="row_box">
        <el-col :span="6">
          <span class="title_name">饲养员:</span>
          <el-input
            disabled
            v-model="feedShop.breeder_name"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          负责时间:
          <el-input
            disabled
            v-model="feedShop.breeder_service_start_time"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          {{ feedShop.breeder_name ? "更换" : "添加" }} 负责人:
          <el-select
            v-model="breederId"
            style="width: 150px"
            placeholder="请选择"
            :disabled="!this.$buttonAuthority('huoti-pethouse-person')"
          >
            <el-option
              v-for="item in salesList"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="6">
          选填备注:
          <el-input
            v-model="breederRemark"
            size="mini"
            style="width: 150px"
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-button type="warning" size="mini" @click="salechangePetManager(1)"
            >确认</el-button
          ></el-col
        >
      </el-row>
   
      <el-row type="flex" class="row_box">
        <el-col :span="6">
          <span class="title_name">医生:</span>
          <el-input
            disabled
            v-model="feedShop.doctor_name"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          负责时间:
          <el-input
            disabled
            v-model="feedShop.doctor_service_start_time"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          {{ feedShop.doctor_name ? "更换" : "添加" }}负责人:
          <el-select
            v-model="doctorId"
            style="width: 150px; margin-left: 5px"
            placeholder="请选择"
            :disabled="!this.$buttonAuthority('huoti-pethouse-person')"
          >
            <el-option
              v-for="item in doctorList"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="6">
          选填备注:
          <el-input
            v-model="doctorRemark"
            size="mini"
            style="width: 150px"
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-button
            type="warning"
            size="mini"
            @click="doctorchangePetManager(4)"
            >确认</el-button
          ></el-col
        >
      </el-row>
         <el-row type="flex" class="row_box">
        <el-col :span="6">
          <span class="title_name"> 医助:</span>
          <el-input
            disabled
            v-model="feedShop.doctor_assistant_name"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          负责时间:
          <el-input
            disabled
            v-model="feedShop.doctor_assistant_service_start_time"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          {{ feedShop.doctor_assistant_name ? "更换" : "添加" }}负责人:
          <el-select
            v-model="doctorAssistantId"
            style="width: 150px"
            placeholder="请选择"
            :disabled="!this.$buttonAuthority('huoti-pethouse-person')"
          >
            <el-option
              v-for="item in assistantList"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="6">
          选填备注:
          <el-input
            v-model="doctorAssistantRemark"
            size="mini"
            style="width: 150px"
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-button
            type="warning"
            size="mini"
            @click="breederchangePetManager(2)"
            >确认</el-button
          ></el-col
        >
      </el-row>
      <el-row type="flex" class="row_box">
        <el-col :span="6">
          <span class="title_name">美容师:</span>
          <el-input
            v-model="feedShop.beautician_name"
            disabled
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          负责时间:
          <el-input
            disabled
            v-model="feedShop.beautician_service_start_time"
            size="mini"
            style="width: 150px"
          ></el-input>
        </el-col>
        <el-col :span="6">
          {{ feedShop.beautician_name ? "更换" : "添加" }}负责人:
          <el-select
            v-model="beauticianId"
            style="width: 150px; margin-left: 5px"
            placeholder="请选择"
            :disabled="!this.$buttonAuthority('huoti-pethouse-person')"
          >
            <el-option
              v-for="item in beauticianList"
              :key="item._id"
              :label="item.basic_info.nick_name"
              :value="item._id"
            >
            </el-option> </el-select
        ></el-col>
        <el-col :span="6">
          选填备注:
          <el-input
            v-model="beauticianRemark"
            size="mini"
            style="width: 150px"
          ></el-input
        ></el-col>
        <el-col :span="6">
          <el-button
            type="warning"
            size="mini"
            @click="beauticianchangePetManager(3)"
            >确认</el-button
          ></el-col
        >
      </el-row>
    </div>
    <!-- 筛选 -->
    <div style="background: #fff">
      <div style="padding: 10px 0px 10px 20px; font-weight: 600">
        宠物负责人
      </div>
      <div class="filter">
        <div class="filterName">：</div>
        <el-select
          v-model="type"
          placeholder="请选择"
          class="titleSelect"
          style="width: 150px"
          size="small"
          clearable
          @change="getTableData"
        >
          <el-option
            v-for="item in [
              { name: '销售 ', value: 1 },
              { name: '饲养员', value: 2 },
              { name: '美容师', value: 3 },
              { name: '医生', value: 4 },
            ]"
            :key="item.value"
            :label="item.name"
            :value="item.value"
          />
        </el-select>
        <div class="filterName">负责时间：</div>
        <el-date-picker
          v-model="comDate"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          size="small"
          style="width: 220px"
          @change="getTableData"
        >
        </el-date-picker>

        <el-button
          type="warning"
          plain
          size="small"
          style="margin-left: 20px"
          @click="resetClick"
          >重置</el-button
        >
      </div>
    </div>
    <!-- 表格 -->
    <el-table :data="tableData" style="width: 100%">
      <el-table-column prop="type.title" label="负责岗位"> </el-table-column>
      <el-table-column prop="staffName" label="负责人"> </el-table-column>
      <el-table-column prop="startTime" label="开始时间">
        <template slot-scope="scope">
          <div>{{ $public.FTime(scope.row.startTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="endTime" label="结束时间">
        <template slot-scope="scope">
          <div>{{ $public.FTime(scope.row.endTime) }}</div>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" label="操作人"> </el-table-column>
      <el-table-column prop="remark" label="备注"> </el-table-column>
    </el-table>
    <!-- 分页 -->
    <!-- <page
      :total="page.total"
      @change="changePage"
      style="margin-top: 22px"
    ></page> -->
  </div>
</template>

  <script>
// import page from "@/components/page.vue";
import { getPetInfo } from "@/api/purchaseApi.js";
import { getStaffList } from "@/api/shopStaff.js";
export default {
  props: {
    id: {
      type: String,
      default: "",
    },
  },
  // components: { page },
  data() {
    return {
      input: "",
      daterange: "",
      operType: "",
      comDate: "", //筛选日期
      type: "",
      tableData: [],
      feedShop: null,
      value: "",
      options: [],
      // page: {
      //   page: 1,
      //   pageSize: 12,
      //   total: 0,
      // },
      params: {
        pageIndex: 1,
        pageSize: 100,
        keyword: "",
        shopId: this.$store.state.shopId,
        position: "",
        status: 1,
      },
      breederRemark: "",
      doctorAssistantRemark: "",
      beauticianRemark: "",
      doctorRemark: "",
      doctorAssistantId: "",
      breederId: "",
      beauticianId: "",
      doctorId: "",
      salesList: [],
      doctorList: [],
      beauticianList: [], //美容师
      breederList: [], //饲养员
      zhuguanList:[],
      assistantList:[],//医助
    };
  },
  mounted() {
    this.getBreederList();
    this.getTableData();
    this.getPetInfo();
    this.getSalesList();
    this.get()
  },
  methods: {
    // 获取管理员变更记录
    getTableData() {
      let params = {
        petId: this.id,
        type: this.type,
      };
      if (this.comDate != "") {
        params.startTime = new Date(this.comDate[0]).getTime() / 1000;
        params.endTime = new Date(this.comDate[1]).getTime() / 1000;
      }
      this.$http
        .get(
          process.env.VUE_APP_Url_baseData +
            "/api/product/pet/manager/change/record/list",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            console.log(res, "变更记录");
            this.tableData = res.data;
          }
        });
    },
    //分页方法
    changePage(num) {
      this.page.page = num;
      this.getTableData();
    },
    // 重置搜索
    resetClick() {
      this.type = "";
      this.comDate = "";
      this.getTableData();
    },
    salechangePetManager(type) {
      if (!this.breederId) {
        this.$message({
          type: "info",
          message: "请选择员工",
        });
        return;
      }
      let params = {
        breederId: this.breederId || "",
        breederRemark: this.breederRemark,
      };
      this.changePetManager(params);
    },
    breederchangePetManager(type) {
      if (!this.doctorAssistantId) {
        this.$message({
          type: "info",
          message: "请选择员工",
        });
        return;
      }
      let params = {
        doctorAssistantId: this.doctorAssistantId || "",
        doctorAssistantRemark: this.doctorAssistantRemark,
      };
      this.changePetManager(params);
    },
    doctorchangePetManager(type) {
      if (!this.doctorId) {
        this.$message({
          type: "info",
          message: "请选择员工",
        });
        return;
      }
      let params = {
        doctorId: this.doctorId || "",
        doctorRemark: this.doctorRemark,
      };
      this.changePetManager(params);
    },
    beauticianchangePetManager(type) {
      if (!this.beauticianId) {
        this.$message({
          type: "info",
          message: "请选择员工",
        });
        return;
      }
      let params = {
        beauticianId: this.beauticianId || "",
        beauticianRemark: this.beauticianRemark,
      };
      this.changePetManager(params);
    },
    // 更新宠物管理
    changePetManager(params) {
      params.petId = this.id;
      console.log(params, "------");
      this.$http
        .post(
          process.env.VUE_APP_Url_baseData +
            "/api/product/pet/update/pet/manager",
          params
        )
        .then((res) => {
          if (res.code == 0) {
            this.reset();
            this.getPetInfo();
            this.getTableData();
            this.$message({
              type: "success",
              message: "已修改",
            });
          }
        });
    },
    reset() {
      this.breederId = "";
      this.doctorAssistantId = "";
      this.beauticianId = "";
      this.doctorId = "";
      this.breederRemark = "";
      this.doctorAssistantRemark = "";
      this.beauticianRemark = "";
      this.doctorRemark = "";
    },
    //获取宠物信息
    getPetInfo() {
      let params = {
        petId: this.id,
      };
      getPetInfo(params).then((res) => {
        if (res.code == 0) {
          console.log("宠物详情信息", res.data);
          let feedShop = res.data.feedShop;
          feedShop.beautician_service_start_time = this.$public.FTime(
            feedShop.beautician_service_start_time
          );
          feedShop.breeder_service_start_time = this.$public.FTime(
            feedShop.breeder_service_start_time
          );
          feedShop.doctor_service_start_time = this.$public.FTime(
            feedShop.doctor_service_start_time
          );
          feedShop.doctor_assistant_service_start_time = this.$public.FTime(
            feedShop.doctor_assistant_service_start_time
          );
          this.feedShop = feedShop;
        }
      });
    },
    getPetManager() {
      // this.saler.id = this.feedShop.sale_id;
      // this.saler.staffName = this.feedShop.sale_name;
      // this.doctor.id = this.feedShop.doctor_id;
      // this.doctor.staffName = this.feedShop.doctor_name;
      // this.breeder.id = this.feedShop.breeder_id;
      // this.breeder.staffName = this.feedShop.breeder_name;
    },
    async get() {
      this.params.position = "主管";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.zhuguanList = res.data.data;
        this.getBreederList()
      }
    },
    // 获取饲养员列表
     async getBreederList() {
      this.params.position = "饲养员";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.breederList = res.data.data;
        this.getSalesList();
      }
    },
    // 获取销售列表
    async getSalesList() {
      this.params.position = "销售";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.salesList = res.data.data;
        this.zhuguanList.map((item)=>{
          this.salesList.push(item)
        })
        this.breederList.map((item)=>{
          this.salesList.push(item)
        })
        this.getDoctorList();
      }
    },
 
    // 获取医生列表
     async getDoctorList() {
      this.params.position = "医生";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.doctorList = res.data.data;
        this.getAssistantList()
      }
    },
         // 获取医生列表
    async getAssistantList() {
      this.params.position = "医助";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.assistantList = res.data.data;
        console.log(this.assistantList,"医助");
        this.getBeauticianList()
      }
    },
    // 获取美容师列表
    async getBeauticianList() {
      this.params.position = "美容师";
      let res = await getStaffList(this.params);
      if (res.code == 0) {
        this.beauticianList = res.data.data;
      }
      console.log(res, "美容师");
    },
  },
};
</script>
<style lang="scss" scoped>
.page {
  min-height: 734px;
  margin-top: 12px;
  font-size: 14px;
  .filter {
    height: 58px;
    display: flex;
    align-items: center;
    background: #fff;

    .sousuo {
      width: 153px;
      margin-right: 4px;
      margin-left: 16px;
    }

    .filterName {
      margin-left: 20px;
      margin-right: 4px;
    }
  }
  .topBox {
    background: #fff;
    margin-bottom: 10px;
    padding: 20px;
    .row_box {
      margin: 10px;
      .title_name {
        text-align: left;
        display: inline-block;
        width: 60px;
      }
    }
  }
}
</style>